module.exports = __webpack_public_path__ + "img/tabicon3.348c8951.png";